import React, { useEffect, useState } from "react";
import { csv } from "d3-fetch";
import { scaleLinear } from "d3-scale";
import {
  ComposableMap,
  Geographies,
  Geography
} from "react-simple-maps";

const colorScale = scaleLinear()
  .domain([0.29, 0.68])
  .range(["#ffedea", "#ff5233"]);

const WorldMap = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    csv("/vulnerability.csv", (d) => ({
      ...d,
      "2017": +d["2017"]
    })).then(setData);
  }, []);

  return (
    <ComposableMap>
      <Geographies geography="/features.json">
        {({ geographies }) =>
          geographies.map((geo) => {
            const d = data.find((s) => s.ISO3 === geo.id);
            return (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill={d && d["2017"] ? colorScale(d["2017"]) : "#F5F4F6"}
              />
            );
          })
        }
      </Geographies>
    </ComposableMap>
  );
};

export default WorldMap;
